module.exports = __webpack_public_path__ + "static/media/IMG_3908.5c63a576.jpg";